import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PosOrderObservationsComponent } from 'src/app/shared/pos-order-observations/pos-order-observations.component';
import { ModalDialogType } from '../constants';
import { PosUnlockOrderObservationsComponent } from './../../shared/pos-unlock-order-observations/pos-unlock-order-observations.component';

@Injectable({
  providedIn: 'root',
})
export class PosOrderObservationsService {
  private modalRef?: BsModalRef;
  private modalRefUnlockObservations?: BsModalRef<PosUnlockOrderObservationsComponent>;

  constructor(private modalService: BsModalService) { }

  async show(
    observations: string,
    confirmAction: (observation: string) => any,
    isDisabled: boolean = false,
    title: string = "Observaciones"
  ) {
    return new Promise((resolve, reject) => {
      this.modalRef = this.modalService.show(PosOrderObservationsComponent, {
        ignoreBackdropClick: true,
      });
      this.modalRef.setClass(
        `modal-dialog modal-md modal-md-height ${ModalDialogType.PRIMARY}`
      );
      this.modalRef.content.observations = observations;
      this.modalRef.content.isDisabled = isDisabled;
      this.modalRef.content.title = title;
      this.modalRef.content.load();
      this.modalRef.content.confirmAction = confirmAction;

      resolve(true);
    });
  }

  async showUnlockOrderObservations(
    observations: string,
    isDisabled: boolean = false,
    title: string = "Observaciones"
  ): Promise<string | undefined> {
    this.modalRefUnlockObservations = this.modalService.show(
      PosUnlockOrderObservationsComponent,
      {
        initialState: { isDisabled, observations, title },
        class: `modal-dialog modal-md modal-md-height ${ModalDialogType.WARNING}`,
      }
    );

    this.modalRefUnlockObservations.content?.load();

    return this.modalRefUnlockObservations.content?.observationsEmitter.toPromise();
  }
}
